/**
 * @desc logisticsMatch
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.LogisticsMatchResponseDto>;
export function request(body: defs.tms.LogisticsMatchRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logistics/match`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
